module.exports = __webpack_public_path__ + "img/C06TechIronWheels_ua.45c396d8.webp";